import { IAction } from '@/redux/actions/action-helpers'
import { IndustriesTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

type IndustriesState = ApplicationState['industries']

export function industriesReducer(state: IndustriesState = [], action: IAction): IndustriesState {
	switch (action.type) {
		case IndustriesTypes.GetIndustries.SUCCESS:
			return action.payload.industries
	}
	return state
}
